import 'jquery';
import '../utils/slick.js';

$(function () {
  const slider1 = $(
    '.feature-cards .feature-cards__cards.block-slider:not(.eslide)'
  );
  const slider2 = $('.feature-cards .feature-cards__cards.block-slider.eslide');

  function initSlider1() {
    slider1.slick({
      centerMode: true,
      centerPadding: '50px',
      slidesToShow: 1,
      prevArrow: '<div class="arrow-left"></div>',
      nextArrow: '<div class="arrow-right"></div>'
    });
  }

  function initSlider2() {
    slider2.slick({
      slidesToShow: 6,
      prevArrow: '<div class="arrow-left"></div>',
      nextArrow: '<div class="arrow-right"></div>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: 1
          }
        }
      ]
    });
  }

  if (slider2.length > 0) {
    initSlider2();
  } else {
    initSlider1();
  }
});
